"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.23.0
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useRef } from 'react';
import { DropdownCategoryType } from '../shared.mjs';
import { getRefElement } from '../../../helpers/getRefElement.mjs';
import '../../../styled-system/css/css.mjs';
import '../../../styled-system/helpers.mjs';
import { sva } from '../../../styled-system/css/sva.mjs';
import { ComboboxContainer } from '../../ComboBoxElements/ComboboxContainer/index.mjs';
import { isClickOnEditorComponent } from '../../ComboBoxElements/Editor/helpers/clicks.mjs';
import '../../DataBuilderUI/FieldControlPanel/index.mjs';
import { ActionBar } from '../../DataBuilderUI/ActionBar.mjs';
import '../../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../../DataBuilderUI/styles.module.css.mjs';
import '../../DataBuilderUI/Row.mjs';
import '../../DataBuilderUI/Title.mjs';
import { ComboBoxValueBadge } from '../Badges/ComboBoxValueBadge.mjs';
import { isDefinedValue } from '../Badges/isDefinedValue.mjs';
import { useComboBox } from '../context/combobox-context.mjs';
import { useComboBoxDropdownContext } from '../context/combobox-dropdown-context.mjs';
import { Dropdown } from '../Dropdown/Dropdown.mjs';

const badgeWrapperRecipe = sva({
  className: "badge-wrapper",
  slots: ["root", "action-bar"],
  base: {
    root: {
      position: "relative",
      display: "inline-flex",
      maxW: "full",
      w: "fit-content"
    },
    "action-bar": {
      display: "none"
    }
  },
  variants: {
    expanded: {
      true: {
        "action-bar": {
          position: "absolute",
          top: "0",
          left: "full",
          bottom: "0",
          mr: "0",
          w: "0",
          zIndex: "1"
        }
      },
      false: {}
    }
  }
});
function ComboboxTagTrigger({
  placeholder,
  className,
  onChange,
  disabled,
  valueComponent,
  ...rest
}) {
  const valueRef = useRef(null);
  const fieldValueRef = useRef(null);
  const {
    refsToIgnoreClick,
    // Dropdown related
    isDropdownOpen,
    openDropdown,
    closeDropdown,
    topDropdownPanelComponent,
    value
  } = useComboBox();
  const { activeCategory } = useComboBoxDropdownContext();
  function handleOpenDropdown() {
    if (disabled) return;
    openDropdown();
  }
  const refs = [valueRef, fieldValueRef, ...refsToIgnoreClick ?? []];
  const handleClick = function handleClick2(e) {
    const isClickInsideAnyOfElements = refs.map(getRefElement).some((el) => el.contains(e?.target));
    if (isClickInsideAnyOfElements && !isClickOnEditorComponent(e?.target, fieldValueRef?.current)) {
      handleOpenDropdown();
      e?.stopPropagation();
    }
  };
  function handleOptionSelect(option) {
    const keepDropdownOpen = activeCategory && [DropdownCategoryType.SELECT_FROM_UDM_DYNAMICALLY].includes(activeCategory);
    onChange(option);
    if (!keepDropdownOpen) {
      closeDropdown();
    }
  }
  const handleOnDelete = () => {
    onChange(void 0);
    closeDropdown();
  };
  const styles = badgeWrapperRecipe({ expanded: isDropdownOpen });
  return /* @__PURE__ */ jsx(
    ComboboxContainer,
    {
      ref: fieldValueRef,
      "aria-expanded": isDropdownOpen,
      "data-tag-dropdown-open": isDropdownOpen,
      "data-selected": rest["data-selected"],
      onClick: handleClick,
      disabled,
      level: "tag",
      children: /* @__PURE__ */ jsx(
        Dropdown,
        {
          topDropdownPanelComponent,
          autoFocusOnSearch: true,
          onOptionSelect: handleOptionSelect,
          children: /* @__PURE__ */ jsx("span", { className: styles.root, ref: valueRef, children: valueComponent ? /* @__PURE__ */ jsxs(Fragment, { children: [
            valueComponent,
            isDefinedValue(value) && /* @__PURE__ */ jsx(ActionBar, { className: styles["action-bar"], children: /* @__PURE__ */ jsx(ActionBar.DeleteButton, { onClick: handleOnDelete }) })
          ] }) : /* @__PURE__ */ jsx(
            ComboBoxValueBadge,
            {
              className,
              placeholder,
              disabled,
              isDropdownOpen,
              onDelete: handleOnDelete
            }
          ) })
        }
      )
    }
  );
}

export { ComboboxTagTrigger };
